import React, { useState, useEffect, useCallback } from 'react';
import './WordCountInfo.css';
import contentData from '../../data/wordCountGuideContent.json';

interface WordCountInfoProps {
  isOpen: boolean;
  onClose: () => void;
}

const WordCountInfo: React.FC<WordCountInfoProps> = ({ isOpen, onClose }) => {
  const [content, setContent] = useState<any>(null);

  useEffect(() => {
    setContent(contentData);
  }, []);

  const handleKeyDown = useCallback((event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, handleKeyDown]);

  if (!isOpen || !content) return null;

  return (
    <div className={`overlay ${isOpen ? 'open' : ''}`}>
      <div className={`popup ${isOpen ? 'open' : ''}`}>
        <button className="close-button" onClick={onClose}>X</button>
        <h3>{content.title}</h3>
        {content.content.map((paragraph: any, index: number) => (
          <p key={index} dangerouslySetInnerHTML={{ __html: paragraph.text }} />
        ))}
      </div>
    </div>
  );
};

export default WordCountInfo;